<template>
    <div>
        <Navbar Title='To-Do List'/>
        <div class="container">
        <div  class="card">
            <Navbar2/>
            <TodoIndex/>
        </div>
        </div>
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Navbar2 from '@/components/Project-components/Todo-app/Navbar'
import TodoIndex from '@/components/Project-components/Todo-app/Todo-Index'
export default {
    name: 'Todo-app',
    components: {
        Navbar2,
        Navbar,
        TodoIndex
    }
}
</script>